// Footer Accordion Functionality
const accordionHeader = document.querySelectorAll('.fp-accordion__header')
const toggleAccordion = e => {
  const content = e.target.nextElementSibling
  content.classList.toggle('open')
}
accordionHeader.forEach(item => {
  item.addEventListener('click', toggleAccordion)
})
